import { otherApiClient } from ".";
export const getReviews = async (payload)=>{
    const { data  } = await otherApiClient.market("/reviews/".concat(payload.type, "/").concat(payload.id), {
        params: payload.pagination
    });
    return data;
};
export const putReviewsLike = async (payload)=>{
    const { data  } = await otherApiClient.market.put("/reviews/".concat(payload.id, "/like/").concat(payload.status));
    return data;
};
export const deleteReview = async (payload)=>{
    const { data  } = await otherApiClient.market.delete("/reviews/".concat(payload.id));
    return data;
};
export const postReview = async (params)=>{
    const { data  } = await otherApiClient.market.post("/reviews", params);
    return data;
};
export const getAssetsForReviewForm = async (params)=>{
    const { data  } = await otherApiClient.market("/reviews/selections", {
        params
    });
    return data;
};
